export const ENTITY_TABLE: Record<string, string> = {
  customer: '3dmachine_customers',
  quote: '3dmachine_quotes',
  project: '3dmachine_projects',
  task: '3dmachine_tasks',
  collection: '3dmachine_collections',
  payment: '3dmachine_payments',
  purchase: '3dmachine_purchases',
  service: '3dmachine_service_records',
  receivable: '3dmachine_receivables',
  file: '3dmachine_files',
};

export const tableFor = (type: string) => ENTITY_TABLE[type] ?? type;